export default class {
  /**
   * Calculate reducing balance repayment
   * 
   * @param {number} ir   - interest rate per month
   * @param {number} np   - number of periods (months)
   * @param {number} pv   - present value
   * @param {number} fv   - future value
   * @param {number} type - when the payments are due:
   *        0: end of the period, e.g. end of month (default)
   *        1: beginning of period
   *
   * @return {number} repayment amount
   */
   static PMT(ir, np, pv, fv, type) {
    let pmt = 0;
    let pvif = 0;

    fv || (fv = 0);
    type || (type = 0);

    if (ir === 0) return -(pv + fv) / np;

    pvif = Math.pow(1 + ir, np);
    pmt = (-ir * pv * (pvif + fv)) / (pvif - 1);

    if (type === 1) pmt /= 1 + ir;

    return pmt;
  }

  /**
   * Convert month term to frequency period 
   *
   * @param {number} period - number of occurance in a year 
   * @param {number} term -  
   *
   * @return {number} loan term/tenure
   */
  static getFrequencyTerm(period=12, term = 0) {
   return (term / 12) * period;
  }
  
  /**
   * Convert annual interest to frequency interest 
   *
   * @param {number} period - number of occurance in a year 
   * @param {number} interest -  loan annual interest
   *
   * @return {number} loan term/tenure
   */
  static getFrequencyInterest(period=12, interest = 0) {
    return interest / period;
  }

  /**
   * Calculates loan repayment 
   *
   * @param {number} principal - loan amount 
   * @param {number} term -  
   * @param {number} intr - interest rate 
   * @param {number} type -  
   * @param {'reducing' | 'add-on'} subType  - repayment calculation type 
   *
   * @return {number} loan term/tenure
   */
  static calculateRePaymentAmount(principal, term, intr, type, subType) {
    if (!principal || !term) return 0;

    let payment = 0;
    const nPer = term;
    const interest = intr;
    if (subType === "revolving" && type === "percentage_of") {
      payment = principal * interest || 0;
    } else if (type !== "reducing") {
      const frequencyIntr = principal * interest * nPer;
      payment = (principal + frequencyIntr) / nPer;
    } else {
      payment = principal / nPer;
      if (interest != 0) {
        payment = this.PMT(interest, nPer, -principal, null, null);
      }
    }
    return { payment, interest, nPer };
  }
    
  /**
   * Calculates loan term/tenure
   *
   * @param {number} principal - loan amount 
   * @param {number} payment - loan payment 
   * @param {number} intr - interest rate 
   * @param {'reducing' | 'add-on'} type  - repayment calculation type 
   *
   * @return {number} loan term/tenure
   */
  static calculateTenure(principal, payment, intr, type) {
    let term = 0;

    if (type !== "reducing") {
      term = +(principal / Math.abs((payment - principal * intr))).toFixed(1);
    } else {
      if (intr !== 0) {
        let count = 0;
        let principalPortion = 0;
        let interestPortion = 0;
        while (principal > payment) {
          interestPortion = principal * intr;
          principalPortion = payment - interestPortion;

          if (principalPortion > principal) {
            principalPortion = principal;
            principal = 0.0;
          } else {
            principal -= principalPortion;
          }

          count += 1;
        }
        count += principal / payment;
        term = count;
      } else {
        term = principal / payment;
      }
    }

    return term;
  }

}
